<template>
    <div class="tabs-widget">
        <div class="tab-item" :class="{ active: activeTab == 'channel_settings' }" @click="switchTab('channel_settings')">
            <img
                :src="activeTab == 'channel_settings' ? require(`@/assets/images/icons/cst_channel_active.svg`) : require(`@/assets/images/icons/cst_channel.svg`)">
            CHANNEL SETTINGS
        </div>
        <div class="tab-item" :class="{ active: activeTab == 'app_settings' }" @click="switchTab('app_settings')">
            <img
                :src="activeTab == 'app_settings' ? require(`@/assets/images/icons/cst_website_active.svg`) : require(`@/assets/images/icons/cst_website.svg`)">
            WEBSITE SETTINGS
        </div>
        <div class="tab-item" :class="{ active: activeTab == 'account_settings' }" @click="switchTab('account_settings')">
            <img
                :src="activeTab == 'account_settings' ? require(`@/assets/images/icons/cst_profile_active.svg`) : require(`@/assets/images/icons/cst_profile.svg`)">
            ACCOUNT SETTINGS
        </div>
        <div class="tab-item" :class="{ active: activeTab == 'users_settings' }" @click="switchTab('users_settings')">
            <img
                :src="activeTab == 'users_settings' ? require(`@/assets/images/icons/people_active.svg`) : require(`@/assets/images/icons/people.svg`)">
            USERS SETTINGS
        </div>
    </div>
</template>
        
<script>
export default {
    components: {},
    sockets: {},
    props: {
        activeTab: {
            type: String,
            default: "",
        },
    },
    data: () => ({}),
    watch: {},
    mounted() {
        let vm = this;
    },
    methods: {
        switchTab(type) {
            let vm = this;
            vm.$emit("selected", type);
        },
    },
};
</script>
<style lang="scss" scoped>
.tabs-widget {
    display: flex;
    flex-direction: column;
    padding: 10px 15px 0 6px;

    @media (max-width: 650px) {
        width: 100%;
        height: 70px;
        align-items: center;
        flex-direction: row;
        overflow-x: auto;
        column-gap: 10px;
    }

    .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-left: 3px solid #fff;

        @media (max-width: 800px) {
            white-space: nowrap;
        }

        img {
            margin: 0 8px 0 10px;
            display: inline-flex;
        }

        &.active {
            color: var(--wecodefy-secondary-color, #9fc953);
            border-left: 3px solid var(--wecodefy-secondary-color, #9fc953);

            @media (max-width: 650px) {
                border-left: unset;
                border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
            }
        }
    }
}
</style>
        